import React, { useEffect, useState } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import './literatureInfo.less';
import { useScrollHeader } from '../../../hooks';

export default function BreakthroughTheory({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)

  const newsData = [
    {
      title: '方法突破 - 结合增强现实的，可以针对弱视眼P通路进行矫正的双眼图像算法',
      desc: 'Xu等人在2010年证明了通过使用推拉（Push-pull）方法来减少眼优势（sensory eye dominance）的可能性。在训练过程中（图 C），受试者的任务是辨别非优势眼看到中的光栅朝向。 刺激首先向受试者的非优势眼呈现一个矩形框（注意提示），然后分别向双眼呈现一对正交光栅。...',
      date: '2024-10-31',
      img: '/images/home/news1.png',
      route: '/fcst/breakthroughMethod',
      type: '文献速递',
    },
    // {
    //   title: '什么是弱视？',
    //   desc: '弱视是一种视觉发育相关疾病，其特征为戴镜视力达不到同龄儿童正常视力下线或者两眼视力相差2行以上，且经眼科检查并未发现能够引起视力差的器质性病变。...',
    //   date: '2024-10-11',
    //   img: '/images/home/news3.png',
    //   route: '/fcst/identifyAmblyopia',
    //   type: '科普专栏',
    // },
    // {
    //   title: '近视防控应该怎么做?',
    //   desc: <>
    //     首先判断是真性近视还是假性近视。<br />
    //     如果孩子出现"假性近视”，可以让孩子眼睛彻底放松，使眼睛慢慢恢复…
    //   </>,
    //   date: '2024-10-11',
    //   img: '/images/home/news4.png',
    //   route: '/fcst/identifyMyopia',
    //   type: '科普专栏',
    // },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>FCST研究院 / 文献速递 / 理论突破-弱视的皮层下受损</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/fcst', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                FCST研究院 / 文献速递
                <span className='ml_54'>2024.10.31</span>
              </div>
              <div className="article_titleBottom">理论突破 - 弱视的皮层下受损</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。<br /><br />
                而既往的神经生物学发现，人脑在处理空间信息时可以进一步分为两条通路，各种对不同的空间特征表现出了不同的神经响应（ref）。其中小细胞（Parvocellular, P）通路被发现是一条主要处理高空间频率信息的通路，同时它还对低时间频率更加敏感，这一特征表明其更善于处理空间中的细节信息，代表视觉信息处理中的慢过程。
              </div>
              <div className='breakthroughTheory-imgBlock'>
                <div className='breakthroughTheory-img'>
                  <img
                    style={{ width: '100%' }}
                    src='/images/fcst/breakthroughTheory1.png'
                    alt=''
                  />
                </div>
                <div className='breakthroughTheory-img'>
                  <img
                    style={{ width: '100%' }}
                    src='/images/fcst/breakthroughTheory2.png'
                    alt=''
                  />
                </div>
              </div>
              <div className="article_content-text">
                相对应的，M通路（Magnocellular, M）被发现是一条主要处理低空间频率信息的通路，同时它还对高时间频率更加敏感，表明其更善于处理空间中的粗略的运动信息，代表视觉信息处理中的快过程。 如果弱视患者的重要临床表现在于弱视眼对空间细节的敏感度降低，那么其更善于处理空间中的细节信息的P通路是否也会表现出受损呢？
                <br />
                <br />
                长期以来，由于M/P通路的分层发生在人脑皮层下的核心深处（主要表现在外膝体上）， 常规的脑成像方法很难获得清晰的成像，使得上述假设缺乏科学的证据证明。近期，中科院生物物理生所与上海复旦眼耳鼻喉科医院依托先进的高场磁共振技术，对弱视患者的皮层下核团进行了研究（ref）。
                <br />
                <br />
                高场磁共振是一种在核磁共振成像过程中采用更高磁场的技术，常规医院检查与研究中，常见的成像磁场为1.5 Tesla与3 Tesla，而高场磁共振则使用了7 Tesla进行成像。
                <br />
                <br />
                通过该方法，研究者可以获得更为清晰的皮层下成像， 从而进一步探究弱视患者的皮层下通路与正常被试的异同。
                <br />
                <br />
                结果发现，当弱视眼呈现高空间频率刺激时，外膝体小细胞层的响应相对于大细胞层同样出现了更大程度的下降。同时对皮层与皮层下核团的功能连接分析结果也显示， 弱视眼从外膝体P层到皮层V1的前馈连接减弱。
                <br />
                <br />
                这些结果都表明弱视患者弱视眼在小细胞通路存在功能上的损伤。这一结果帮助我们更精准的定位了弱视患者视觉系统中异常的病灶所在，为后期开发出一套更针对，更有效的弱视矫正方法提供了重要的理论基础。
              </div>
              <div className="breakthroughTheory-img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/home/numberplan.jpg'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。
                <br />
                <br />
                而既往的神经生物学发现，人脑在处理空间信息时可以进一步分为两条通路，各种对不同的空间特征表现出了不同的神经响应（ref）。其中小细胞（Parvocellular, P）通路被发现是一条主要处理高空间频率信息的通路，同时它还对低时间频率更加敏感，这一特征表明其更善于处理空间中的细节信息，代表视觉信息处理中的慢过程。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlockLiterature'>
              <div>
                <div className='article_content-literatureText'>点击获取文献原文</div>
                <a
                  className='article_content-literatureLink c_85899E'
                  href="https://www.cell.com/cell-reports/fulltext/S2211-1247(21)01611-9"
                  target='_'
                >
                  https://www.cell.com/cell-reports/fulltext/S2211-1247(21)01611-9
                </a>
              </div>
              <div className='flex_row gap_20'>
                <div className='PreA_left-icon flex_center'>
                  <img
                    src='/images/news/Share_icon.png'
                    alt=''
                  />
                </div>
                <div className='PreA_left-icon flex_center'>
                  <img
                    src='/images/news/Collection_icon.png'
                    alt=''
                  />
                </div>
                <div className='PreA_left-icon flex_center'>
                  <img
                    src='/images/news/link_icon.png'
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                // onClick={(() => navigate('/fcst/identifyMyopia'))}
                onClick={(() => navigate('/fcst/breakthroughMethod'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇文章
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/breakthroughMethod'))}
              >
                阅读下一篇文章
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                // onClick={(() => navigate('/fcst/identifyMyopia'))}
                onClick={(() => navigate('/fcst/breakthroughMethod'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/breakthroughMethod'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PreA_right">
        <div className="PreA_marginMobile">
          <div className='PreA_right-searchBlock flex_row flex_ai-c'>
            <div className='of_hidden' style={{ width: '100%' }}>
              <input
                className="PreA_input flex_full"
                style={{ width: '100%' }}
                type="text"
                // value={demand}
                // onChange={(e) => setDemand(e.target.value)}
                placeholder="搜索文章"
              />
              <div className='PreA_input-line'></div>
            </div>
            <img
              className='PreA_right-icon flex_auto'
              src='/images/news/right.png'
              alt=''
            />
          </div>
          <div className="article_rightType">
            <div className='fz_18 fw_500 lh_21'>文章分类</div>
            <div className='PreA_right-item flex_center'>文献速递</div>
          </div>
          <div className="article_rightMore">
            <div className='fz_18 fw_500 lh_21'>更多文章</div>
            <div className="mt_16">
              <div className="of_hidden">
                <div className='article_rightMoreBlock flex_col'>
                  {newsData.map((item, index) => <div
                    key={index}
                    className='article_rightItem cur_p'
                    onClick={(() => navigate(item.route))}
                  >
                    <div className="article_rightItemBlock">
                      <div className='PreA_right-itemImg flex_center'>
                        <img
                          style={{ width: '100%' }}
                          src={item.img}
                          alt=''
                        />
                      </div>
                      <div className='article_rightItem-date c_85899E flex_row flex_jc-sb'>
                        <div>{item.date}</div>
                        <div className='article_rightItem-type'>FCST研究院 / {item.type}</div>
                      </div>
                      <div className='article_rightItem-title of_ellipsis'>{item.title}</div>
                      <div className='article_rightItem-desc multiline-ellipsis-2'>{item.desc}</div>
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
            <div className="PreA_right-btnBlock">
              <div
                className='PreA_right-btn flex_row flex_jc-c flex_ai-c'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={(() => navigate('/fcst'))}
              >
                更多文章
                <img
                  class="PreA_right-arrow"
                  alt=""
                  src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
}
